import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
} from "@redotech/redo-model/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getContextLibraryItems = {
  name: "getContextLibraryItems" as const,
  input: z.object({
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
    searchText: z.string().optional(),
    marketingAgentPromptIds: z.array(zExt.objectId()).optional(),
    channel: z.nativeEnum(AutomationChannel).optional(),
    type: z.nativeEnum(AiContextLibraryType).optional(),
  }),
  output: z.object({
    data: z.array(AiContextLibrarySchema as z.ZodType<AiContextLibrary>),
    paginationKey: z.string().optional(),
    totalCount: z.number().optional(),
    currentPage: z.number().optional(),
    totalPages: z.number().optional(),
  }),
};
